import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useWritePromptUpdate = () => {
  const createWritePromptUpdateRequest = useCallback((payload) => {
    const { promptId, text } = payload;

    const body = {
      text,
    };

    const requestUrl = `${API_BASE_URL}/api/v2/prompt/${promptId}/`;

    return new Request(requestUrl, {
      method: "POST",
      body: JSON.stringify(body),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(createWritePromptUpdateRequest);
};

export default useWritePromptUpdate;
